import React, { Suspense } from 'react';

import { createTheme, themeDark, ThemeProvider as MuiThemeProvider } from '@ui-kit';

import { hubRoot } from './root';

const AppWithStyle = React.lazy(() => import('./AppWithStyle'));

const theme = createTheme(themeDark);

/**
 * Entry point
 */
hubRoot.render(
  <MuiThemeProvider theme={theme}>
    <Suspense fallback={null}>
      <AppWithStyle />
    </Suspense>
  </MuiThemeProvider>
);
